import React, { useState } from 'react';

const PlanTypeList = ({ planTypes, onEdit }) => {
  const [search, setSearch] = useState('');

  const filteredPlanTypes = planTypes.filter((pt) =>
    pt.plan_type.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="max-w-4xl bg-white rounded shadow p-6 mx-auto">
      <h2 className="text-xl font-semibold mb-4">Plan Types</h2>

      <input
        type="text"
        placeholder="Search plan types..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="w-full px-4 py-2 border rounded mb-4"
      />

      <table className="w-full border">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 text-left">Plan Type</th>
            <th className="p-2 text-left">Created At</th>
            <th className="p-2 text-left">Updated At</th>
          </tr>
        </thead>
        <tbody>
          {filteredPlanTypes.map((planType) => (
            <tr
              key={planType.id}
              onClick={() => onEdit(planType)}
              className="cursor-pointer hover:bg-gray-50 border-t"
            >
              <td className="p-2">{planType.plan_type}</td>
              <td className="p-2 text-sm text-gray-500">
                {new Date(planType.createdAt).toLocaleDateString()}
              </td>
              <td className="p-2 text-sm text-gray-500">
                {new Date(planType.updatedAt).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PlanTypeList;
